/* tslint:disable:object-literal-sort-keys */

export const messages = {
    "en": {
        "countryCode": "gb",
        "auth": {
            "login": {
                "error": {
                    "credentials": "Username and/or password incorrect",
                    "network": "Communication with server has failed"
                },
                "form": {
                    "password": {
                        "error": "Please enter your username",
                        "label": "Password"
                    },
                    "submit": "Log in",
                    "submitting": "Logging in",
                    "username": {
                        "error": "Please enter your password",
                        "label": "Username"
                    }
                }
            },
            "renew": {
                "slowNetwork": "This is taking more time than usual. Please do not quit the application.",
                "spinner": "Getting you back online"
            }
        },
        "actionBar": {
            "newItems": "New Items",
            "auditCampaign": "Audit Campaigns",
            "synchro": "Synchro"
        },
        "navbar": {
            "contextMenuModal": {
                "buildDate": "Deployment",
                "checkForUpdate": {
                    "help": "If an update is available, it will be installed automatically.",
                    "title": "Please check for updates"
                },
                "clearCache": {
                    "help": "If you are offline, this process will remove access to all data stored on your device",
                    "title": "Clear cache memory"
                },
                "overrideLocale": {
                    "help": "The english langage will be used and your device’s settings will be ignored",
                    "title": "Force english langage"
                },
                "resetLocaleOverride": {
                    "help": "The langage will depend on your device’s settings",
                    "title": "Reset the language"
                },
                "title": "Skin-REPORTER"
            },
            "logout": "Are you sure that you want to log out?"
        },
        "offlineRibbon": {
            "offline": "You are now offline",
            "online": "You are now online"
        },
        "proxy": {
            "error": {
                "default": "An error occured on the resource {uri}",
                "network": "Communication with the server has failed",
                "notFound": "The resource {uri} could not be found",
                "tokenHasExpired": "Your session has expired"
            }
        },
        "serviceWorker": {
            "updateAvailable": "An update has been installed. You can either click here to refresh the page or restart the application."
        },
        "itemCard": {
            "detailsNotAvailable": "Details not available",
            "error": "The item cannot be displayed",
            "identifier": "N° Inv. {identifier}",
            "identifierError": "Identifier error",
            "location": "Location",
            "locationLabel": "Destination: <strong>{title}</strong>",
            "unknownLocation": "Unkonwn",
            "title": "Title",
            "locationSelector": {
                "title": "Select a location",
                "validate": "Validate"
            }
        },
        "entity": {
            "addItem": {
                "error": {
                    "api": "The object could not be added",
                    "network": "The communication with the server has failed"
                },
                "form": {
                    "id": {
                        "alreadyAdded": "The object already exists in this selection",
                        "emptyError": "Please scan an item barcode or type its inventory number",
                        "label": "Inventory number",
                        "notFoundError": "The item is unknown"
                    },
                    "location": {
                        "emptyError": "Select a location",
                        "label": "Arrival location",
                        "notFoundError": "Unknown location"
                    },
                    "submit": "Add",
                    "submitting": "Adding..."
                },
                "modal": {
                    "title": "Add an item"
                }
            },
            "closeMovement": {
                "form": {
                    "location": {
                        "inputPlaceholder": "Select a location...",
                        "noResult": "There is no result"
                    }
                }
            }
        },
        "firewall": {
            "collabWarningMessage": "Your account doesn't any associated collaborator, the app may be disfunctionning",
            "noGroupForUserWarningMessage": "You user account needs to be part of group of users to be able to user SKINreporter"
        },
        "maskFields": {
            "boolean": {
                "no": "No",
                "undefined": "Undefined",
                "yes": "Yes"
            },
            "entitySelect": {
                "modalPlaceholder": "Keywords or identifiers..."
            }
        },
        "editItemScreen": {
            "author": "Author",
            "inventoryNumber": "Inventory Number",
            "confirmButton": "Save",
            "editButton": "Edit",
            "saveNotification": {
                "errorMessage": "En error occured while saving the item",
                "successMessage": "Item successfully saved"
            },
            "deleteNotification": {
                "errorMessage": "TRANSLATING IN PROGRESS",
                "successMessage": "TRANSLATING IN PROGRESS"
            },
            "deleteModificationsNotification": {
                "errorMessage": "TRANSLATING IN PROGRESS",
                "successMessage": "TRANSLATING IN PROGRESS"
            },
            "errorMessages": {
                "inventoryNumberNotUnique": "This inventory number is already attributed"
            },
            "menu": {
                "saveModifications": "Save modifications",
                "deleteNotSynchronizedNewItem": "TRANSLATING IN PROGRESS",
                "deleteModificationsNotSynchronized": "Delete unsynchronized modifications",
                "offlineWarning": "Modifications are saved on this device, you will have to synchronize them with the database when the network is back.",
                "offlineShortWarning": "Modified on this device",
                "addToCampaign": "MISSING TRANSLATION"
            }
        },
        "editRecordScreen": {
            "auditDate": "Audit date",
            "linkedObject": "Linked item",
            "realTimeLocation": "Realtime location",
            "itemNotice": "Go to item",
            "recordStatus": "Record status",
            "foldAll": "Fold all",
            "unfoldAll": "Unfold all",
            "medias": {
                "accordionPanelTitle": "ATTACHED MULTIMEDIA"
            },
            "menu": {
                "saveModifications": "Save modifications",
                "changeRecordStatus": "Change record status",
                "statusModificationWarning": "Confirm modification ?",
                "offlineWarning": "Modifications are saved on this device, you will have to synchronize them with the database when the network is back.",
                "offlineShortWarning": "Modified on this device"
            },
            "notifications": {
                "saveError": "An error occurred while saving",
                "saveSuccess": "Record saved",
                "stateTransitionError": "An error occurred while modifying the record",
                "stateTransitionSuccess": "record status successfully updated"
            }
        },
        "defectTree": {
            "annotation": {
                "deleteConfirmationMessage": "Confirm deletion ?",
                "defaultImageConfirmationMessage": "Set as default image ?"
            }
        },
        "itemSearchScreen": {
            "camera": "CAMERA",
            "modifyRecord": "MODIFY ITEM RECORD",
            "createNewItem": "CREATE NEW ITEM"
        },
        "searchFeaturedCard": {
            "institutionLabel": "Institution"
        },
        "auditCampaignSearchScreen": {
            "inProgress": "In progress",
            "title": "Audit Campaigns in progress",
            "noResultsPlaceholder": "You are not authorized to work on any campaign at this time"
        },
        "recordSearchScreen": {
            "auditors": "Auditors",
            "campaignManager": "Campaign manager",
            "inventoryNumber": "Inventory number",
            "projectCreationDate": "Project creation date",
            "projectType": "Project type",
            "realTimeLocation": "Realtime location",
            "recordRefNumber": "Record reference number",
            "status": "Status",
            "title": "Audit records",
            "unknowLocation": "Unknown location",
            "menu": {
                "addItem": "Add item"
            }
        },
        "state": {
            "all": "All",
            "archived": "Archived",
            "canceled": "Canceled",
            "finalized": "Finalized",
            "inPreparation": "In preparation",
            "inProgress": "In progress",
            "programmed": "Programmed",
            "toValidated": "Needs validation",
            "validated": "Validated",
            "aborted": "Aborted",
            "success": "Successfully finished",
            "error": "Error",
            "none": "No previous synchronization"
        },
        "time": {
            "hours": "hour(s)",
            "minutes": "minute(s)",
            "seconds": "second(s)"
        },
        "locationSelector": {
            "inputPlaceholder": "Type a location",
            "title": "Select a location",
            "validate": "Validate"
        },
        "synchroModal": {
            "title": "Synchronization",
            "lastFetch": "Last fetching",
            "duration": "Duration",
            "status": "Status",
            "details": "Details",
            "lastSynchro": "Last synchronization",
            "noEntityToSync": "No entity to synchronize",
            "connectionWarningPrefix": "You must have an internet connection to be able to",
            "connectWarningSend": "send",
            "connectWarningRetrieve": "retrive",
            "connectionWarningSuffix": "data",
            "noDataToSync": "No data to synchronize for now",
            "localIconInfoPrefix": "The icon",
            "localIconInfoSuffix": " indicates that the corresponding data has been modified localy and will need to be synchronized with the remote database.",
            "retrieveAll": "Retrieve All",
            "finishedSynchros": "Finished synchronizations",
            "syncAll": "Sychronize all",
            "remainsToSynchronize": "Remains to synchronize",
            "cleanImageCache": "Clean media in cache",
            "cachedImagedCleaned": "Gohst media have been cleaned !",
            "cleanCacheDown": "Clear the cache",
            "cacheDownCleaned": "The cache has been cleared",
            "cleanCacheUp": "Delete every unsynchronized modifications",
            "cacheUpCleaned": "All unsynchronized modifications have been deleted !"
        },
        "entityNames": {
            "items": "Items",
            "auditRecords": "Audit records",
            "audits": "Audit campaings",
            "thesaurusTerms": "Thesaurus terms",
            "thesaurus": "Thesaurus",
            "entityFields": "System data",
            "collaborators": "Collaborators",
            "authorities": "Authorities",
            "aliases": "Aliases",
            "locations": "Locations",
            works: "Works",
            expressions: "Expressions",
            manifestations: "Manifestations",
        },
        "search": {
            "options": {
                "sortType": {
                    "auditType": "Type of project",
                    "campaignCreationDate": "Campaign creation date",
                    "identificationNumber": "Identification number",
                    "creationDate": "Date of Creation",
                    "identifier": "Main identifier",
                    "lastModification": "Last Modification",
                    "mainTitle": "Main Title",
                    "referenceNumber": "Reference number"
                }
            },
            "queryPlaceholder": "Keywords or campaign number",
            "totalCount": "{totalResults} Result(s) : 1 -",
            "noResults": "No results",
            "title": "Museum objects"
        },
        "itemCreationImagePopup": {
            "title": "Add an image",
            "addImage": "ADD AN IMAGE",
            "ignore": "LATER, IGNORE THIS STAGE"
        }
    },
    "fr": {
        "auth": {
            "login": {
                "error": {
                    "credentials": "Vos identifiants sont incorrects",
                    "network": "La communication avec le serveur a échoué"
                },
                "form": {
                    "password": {
                        "error": "Veuillez saisir votre nom d'utilisateur",
                        "label": "Mot de passe"
                    },
                    "submit": "Se connecter",
                    "submitting": "Connexion...",
                    "username": {
                        "error": "Veuillez saisir votre mot de passe",
                        "label": "Nom d'utilisateur"
                    }
                }
            },
            "renew": {
                "slowNetwork": "Cela semble mettre plus de temps que d'habitude, ne quittez pas l'application.",
                "spinner": "Nous vous reconnectons..."
            }
        },
        "actionBar": {
            "newItems": "Nouveaux objets",
            "auditCampaign": "Campagnes de récolement",
            "synchro": "Synchro"
        },
        "navbar": {
            "contextMenuModal": {
                "buildDate": "Déployé le",
                "checkForUpdate": {
                    "help": "Si une mise à jour est disponible, elle s'installera automatiquement.",
                    "title": "Vérifiez les mises à jour"
                },
                "clearCache": {
                    "help": "Si vous êtes hors-ligne, cela supprime l'accès à toutes les données stockées sur l'appareil.",
                    "title": "Vider le cache"
                },
                "overrideLocale": {
                    "help": "La langue anglaise sera utilisée et le paramétrage de votre terminal ignoré.",
                    "title": "Forcer la langue anglaise"
                },
                "resetLocaleOverride": {
                    "help": "La langue utilisé dépendra du paramètrage de votre terminal",
                    "title": "Réinitialiser la langue"
                },
                "title": "Skin-REPORTER"
            },
            "logout": "Etes-vous sûr de vouloir vous déconnecter ?"
        },
        "offlineRibbon": {
            "offline": "Vous êtes hors connexion",
            "online": "Vous êtes connecté"
        },
        "proxy": {
            "error": {
                "default": "Une erreur s'est produite sur la ressource {uri}",
                "network": "La communication avec le serveur a échoué",
                "notFound": "La ressource {uri} n'a pas été trouvée",
                "tokenHasExpired": "Votre session a expiré"
            }
        },
        "serviceWorker": {
            "updateAvailable": "Une mise à jour a été installée. Cliquez ici pour recharger la page ou relancez l'application"
        },
        "itemCard": {
            "detailsNotAvailable": "Détails non disponible",
            "error": "L'objet ne peut pas être affiché",
            "identifier": "N° Inv. {identifier}",
            "identifierError": "Erreur d'identification",
            "location": "Localisation",
            "locationLabel": "Destination: <strong>{title}</strong>",
            "unknownLocation": "Inconnue",
            "title": "Titre",
            "locationSelector": {
                "title": "Choisissez une localisation",
                "validate": "Valider"
            }
        },
        "entity": {
            "addItem": {
                "error": {
                    "api": "L'objet n'a pas pu être ajouté",
                    "network": "La communication avec le serveur a échoué"
                },
                "form": {
                    "id": {
                        "alreadyAdded": "L'objet est déjà existant dans le mouvement",
                        "emptyError": "Veuillez scanner un objet ou entrer son numéro d'inventaire",
                        "label": "Numéro d'inventaire",
                        "notFoundError": "L'objet est inconnu"
                    },
                    "location": {
                        "emptyError": "Sélectionnez une localisation",
                        "label": "Destination d’arrivée",
                        "notFoundError": "La localisation est inconnue"
                    },
                    "submit": "Ajouter",
                    "submitting": "Ajout..."
                },
                "modal": {
                    "title": "Ajouter un objet"
                }
            },
            "closeMovement": {
                "form": {
                    "location": {
                        "inputPlaceholder": "Entrez une localisation...",
                        "noResult": "Aucun résultat"
                    }
                }
            }
        },
        "firewall": {
            "collabWarningMessage": "Votre compte n'a pas de collaborateur associé, l'application peut dysfonctionner",
            "noGroupForUserWarningMessage": "L'usage de SKINreporter requiert que votre compte utilisateur soit lié à un groupe d'utilisateurs"
        },
        "maskFields": {
            "boolean": {
                "no": "Non",
                "undefined": "Non défini",
                "yes": "Oui"
            },
            "entitySelect": {
                "modalPlaceholder": "Mots clés ou identifiants..."
            }
        },
        "editItemScreen": {
            "author": "Auteur",
            "inventoryNumber": "N° d'inventaire",
            "confirmButton": "Valider",
            "editButton": "Modifier",
            "saveNotification": {
                "errorMessage": "Une erreur est survenue pendant la sauvegarde de l'objet",
                "successMessage": "L'objet a été sauvegardé avec succès"
            },
            "deleteNotification": {
                "errorMessage": "Une erreur est survenue pendant la suppression de l'objet non synchronisés",
                "successMessage": "L'objet a été supprimé avec succès"
            },
            "deleteModificationsNotification": {
                "errorMessage": "Une erreur est survenue pendant la suppression des modifications non synchronisées",
                "successMessage": "Les modifications ont été annulées"
            },
            "errorMessages": {
                "inventoryNumberNotUnique": "Ce numéro d'inventaire est déjà attribué"
            },
            "menu": {
                "saveModifications": "Sauvegarder les modifications",
                "deleteNotSynchronizedNewItem": "Supprimer le nouvel objet",
                "deleteModificationsNotSynchronized": "Supprimer les modifications non synchronisées",
                "offlineWarning": "Les modifications sont sauvegardées sur l'appareil, vous devrez les synchroniser avec la base de données lorsque le réseau sera de nouveau disponible.",
                "offlineShortWarning": "Modifié sur cet appareil",
                "addToCampaign": "Récoler cet objet"
            }
        },
        "editRecordScreen": {
            "auditDate": "Date de récolement",
            "linkedObject": "Objet lié",
            "realTimeLocation": "Localisation en temps réel",
            "itemNotice": "Fiche objet",
            "recordStatus": "Statut de la fiche",
            "foldAll": "Réduire tout",
            "unfoldAll": "Déployer tout",
            "medias": {
                "accordionPanelTitle": "MÉDIAS"
            },
            "menu": {
                "saveModifications": "Sauvegarder les modifications",
                "changeRecordStatus": "Modifier le statut de la fiche",
                "statusModificationWarning": "Confirmer la modification ?",
                "offlineWarning": "Les modifications sont sauvegardées sur l'appareil, vous devrez les synchroniser avec la base de données lorsque le réseau sera de nouveau disponible.",
                "offlineShortWarning": "Modifié sur cet appareil"
            },
            "notifications": {
                "saveError": "Une erreur est survenue lors de la sauvegarde",
                "saveSuccess": "Fiche de récolement sauvegardée",
                "stateTransitionError": "Une erreur est survenue pendant la modification du statu de la fiche",
                "stateTransitionSuccess": "Statut de la fiche modifié avec succès"
            }
        },
        "defectTree": {
            "annotation": {
                "deleteConfirmationMessage": "Confirmer la suppression ?",
                "defaultImageConfirmationMessage": "Définir comme image par défaut ?"
            }
        },
        "itemSearchScreen": {
            "camera": "APPAREIL PHOTO",
            "modifyRecord": "MODIFIER LA FICHE OBJET",
            "createNewItem": "CRÉER UN NOUVEL OBJET"
        },
        "searchFeaturedCard": {
            "institutionLabel": "Institution"
        },
        "auditCampaignSearchScreen": {
            "inProgress": "En cours",
            "title": "Projets de pointage/récolement en cours",
            "noResultsPlaceholder": "Vous n'êtes habilités à travailler sur aucune campagne pour le moment"
        },
        "recordSearchScreen": {
            "auditors": "Récoleurs",
            "campaignManager": "Responsable de la campagne",
            "inventoryNumber": "N° d'inventaire",
            "projectCreationDate": "Date de création du projet",
            "projectType": "Type de projet",
            "realTimeLocation": "Localisation en temps réel",
            "recordRefNumber": "Référence fiche",
            "status": "Statut",
            "title": "Fiches de récolement",
            "unknowLocation": "Localisation Inconnue",
            "menu": {
                "addItem": "Ajouter un objet"
            }
        },
        "state": {
            "all": "Tous",
            "archived": "Archivé",
            "canceled": "Annulé",
            "finalized": "Terminé",
            "inPreparation": "En préparation",
            "inProgress": "En cours",
            "programmed": "Planifié",
            "toValidated": "À valider",
            "validated": "Validé",
            "aborted": "Interrompue",
            "success": "Terminée avec succès",
            "error": "Erreur",
            "none": "Aucune synchronisation précédente"
        },
        "time": {
            "hours": "heure(s)",
            "minutes": "minute(s)",
            "seconds": "seconde(s)"
        },
        "locationSelector": {
            "inputPlaceholder": "Entrez une localisation",
            "title": "Choisissez une localisation",
            "validate": "Valider"
        },
        "synchroModal": {
            "title": "Synchronisation",
            "lastFetch": "Dernière récupération",
            "duration": "Durée",
            "status": "Statut",
            "details": "Détails",
            "lastSynchro": "Dernière synchronisation",
            "noEntityToSync": "Aucune entité à synchroniser",
            "connectionWarningPrefix": "Vous devez être connecté à internet pour pouvoir",
            "connectWarningSend": "envoyer",
            "connectWarningRetrieve": "récupérer",
            "connectionWarningSuffix": "des données",
            "noDataToSync": "Aucune donnée à synchroniser pour le moment",
            "localIconInfoPrefix": "L'icône",
            "localIconInfoSuffix": " indique que les données correspondantes ont été modifiées localement et devront être synchronisées avec la base de données distante.",
            "retrieveAll": "Tout récupérer",
            "finishedSynchros": "synchronisations terminées",
            "syncAll": "Tout synchroniser",
            "remainsToSynchronize": "Reste à synchroniser",
            "cleanImageCache": "Supprimer les images fantômes du cache",
            "cachedImagedCleaned": "Les images fantômes ont été supprimées !",
            cleanCacheDown: "Vider le cache",
            cacheDownCleaned: "Le cache a été vidé",
            cleanCacheUp: "Supprimer toutes les modifications non synchronisées",
            cacheUpCleaned: "Toute les modifications non synchronisées ont étés supprimées",
        },
        "entityNames": {
            "items": "Items",
            "auditRecords": "Fiches de récolement",
            "audits": "Projets de récolement",
            "thesaurusTerms": "Termes de thésaurus",
            "thesaurus": "Thésaurus",
            "entityFields": "Données système",
            "collaborators": "Collaborateurs",
            "authorities": "Autorités",
            "aliases": "Alias",
            "locations": "Localisations",
            works: "Oeuvres",
            expressions: "Expressions",
            manifestations: "Manifestations",
        },
        "search": {
            "options": {
                "sortType": {
                    "auditType": "Type de projet",
                    "campaignCreationDate": "Date de création de la campagne",
                    "creationDate": "Date de création",
                    "identificationNumber": "Numéro d'identification",
                    "identifier": "Identifiant principal",
                    "lastModification": "Dernière modification",
                    "mainTitle": "Titre principal",
                    "referenceNumber": "Numéro de référence"
                }
            },
            "queryPlaceholder": "Mots clés ou N° de campagne",
            "totalCount": "{totalResults}  Résultat(s) : 1 -",
            "noResults": "Aucun résultat",
            "title": "Objets de musée"
        },
        "itemCreationImagePopup": {
            "title": "Ajouter une image",
            "addImage": "AJOUTER UNE IMAGE",
            "ignore": "PLUS TARD, IGNORER CETTE ETAPE"
        }
    },
    "fr-ca": {
        "countryCode": "ca",
        "auth": {
            "login": {
                "error": {
                    "credentials": "Vos identifiants sont incorrects",
                    "network": "La communication avec le serveur a échoué"
                },
                "form": {
                    "password": {
                        "error": "Veuillez saisir votre nom d'utilisateur",
                        "label": "Mot de passe"
                    },
                    "submit": "Se connecter",
                    "submitting": "Connexion...",
                    "username": {
                        "error": "Veuillez saisir votre mot de passe",
                        "label": "Nom d'utilisateur"
                    }
                }
            },
            "renew": {
                "slowNetwork": "Cela semble mettre plus de temps que d'habitude, ne quittez pas l'application.",
                "spinner": "Nous vous reconnectons..."
            }
        },
        "actionBar": {
            "newItems": "Nouveaux objets",
            "auditCampaign": "Campagnes de récolement",
            "synchro": "Synchro"
        },
        "navbar": {
            "contextMenuModal": {
                "buildDate": "Déployé le",
                "checkForUpdate": {
                    "help": "Si une mise à jour est disponible, elle s'installera automatiquement.",
                    "title": "Vérifiez les mises à jour"
                },
                "clearCache": {
                    "help": "Si vous êtes hors-ligne, cela supprime l'accès à toutes les données stockées sur l'appareil.",
                    "title": "Vider le cache"
                },
                "overrideLocale": {
                    "help": "La langue anglaise sera utilisée et le paramétrage de votre terminal ignoré.",
                    "title": "Forcer la langue anglaise"
                },
                "resetLocaleOverride": {
                    "help": "La langue utilisé dépendra du paramètrage de votre terminal",
                    "title": "Réinitialiser la langue"
                },
                "title": "Skin-REPORTER"
            },
            "logout": "Etes-vous sûr de vouloir vous déconnecter ?"
        },
        "offlineRibbon": {
            "offline": "Vous êtes hors connexion",
            "online": "Vous êtes connecté"
        },
        "proxy": {
            "error": {
                "default": "Une erreur s'est produite sur la ressource {uri}",
                "network": "La communication avec le serveur a échoué",
                "notFound": "La ressource {uri} n'a pas été trouvée",
                "tokenHasExpired": "Votre session a expiré"
            }
        },
        "serviceWorker": {
            "updateAvailable": "Une mise à jour a été installée. Cliquez ici pour recharger la page ou relancez l'application"
        },
        "itemCard": {
            "detailsNotAvailable": "Détails non disponible",
            "error": "L'objet ne peut pas être affiché",
            "identifier": "N° Inv. {identifier}",
            "identifierError": "Erreur d'identification",
            "location": "Localisation",
            "locationLabel": "Destination: <strong>{title}</strong>",
            "unknownLocation": "Inconnue",
            "title": "Titre",
            "locationSelector": {
                "title": "Choisissez une localisation",
                "validate": "Valider"
            }
        },
        "entity": {
            "addItem": {
                "error": {
                    "api": "L'objet n'a pas pu être ajouté",
                    "network": "La communication avec le serveur a échoué"
                },
                "form": {
                    "id": {
                        "alreadyAdded": "L'objet est déjà existant dans le mouvement",
                        "emptyError": "Veuillez scanner un objet ou entrer son numéro d'inventaire",
                        "label": "Numéro d'inventaire",
                        "notFoundError": "L'objet est inconnu"
                    },
                    "location": {
                        "emptyError": "Sélectionnez une localisation",
                        "label": "Destination d’arrivée",
                        "notFoundError": "La localisation est inconnue"
                    },
                    "submit": "Ajouter",
                    "submitting": "Ajout..."
                },
                "modal": {
                    "title": "Ajouter un objet"
                }
            },
            "closeMovement": {
                "form": {
                    "location": {
                        "inputPlaceholder": "Entrez une localisation...",
                        "noResult": "Aucun résultat"
                    }
                }
            }
        },
        "firewall": {
            "collabWarningMessage": "Votre compte n'a pas de collaborateur associé, l'application peut dysfonctionner",
            "noGroupForUserWarningMessage": "L'usage de SKINreporter requiert que votre compte utilisateur soit lié à un groupe d'utilisateurs"
        },
        "maskFields": {
            "boolean": {
                "no": "Non",
                "undefined": "Non défini",
                "yes": "Oui"
            },
            "entitySelect": {
                "modalPlaceholder": "Mots clés ou identifiants..."
            }
        },
        "editItemScreen": {
            "author": "Auteur",
            "inventoryNumber": "N° d'inventaire",
            "confirmButton": "Valider",
            "editButton": "Modifier",
            "saveNotification": {
                "errorMessage": "Une erreur est survenue pendant la sauvegarde de l'objet",
                "successMessage": "L'objet a été sauvegardé avec succès"
            },
            "deleteNotification": {
                "errorMessage": "Une erreur est survenue pendant la suppression de l'objet non synchronisés",
                "successMessage": "L'objet a été supprimé avec succès"
            },
            "deleteModificationsNotification": {
                "errorMessage": "Une erreur est survenue pendant la suppression des modifications non synchronisées",
                "successMessage": "Les modifications ont été annulées"
            },
            "errorMessages": {
                "inventoryNumberNotUnique": "Ce numéro d'inventaire est déjà attribué"
            },
            "menu": {
                "saveModifications": "Sauvegarder les modifications",
                "deleteNotSynchronizedNewItem": "Supprimer le nouvel objet",
                "deleteModificationsNotSynchronized": "Supprimer les modifications non synchronisées",
                "offlineWarning": "Les modifications sont sauvegardées sur l'appareil, vous devrez les synchroniser avec la base de données lorsque le réseau sera de nouveau disponible.",
                "offlineShortWarning": "Modifié sur cet appareil"
            }
        },
        "editRecordScreen": {
            "auditDate": "Date de récolement",
            "linkedObject": "Objet lié",
            "realTimeLocation": "Localisation en temps réel",
            "itemNotice": "Fiche objet",
            "recordStatus": "Statut de la fiche",
            "foldAll": "Réduire tout",
            "unfoldAll": "Déployer tout",
            "medias": {
                "accordionPanelTitle": "MÉDIAS"
            },
            "menu": {
                "saveModifications": "Sauvegarder les modifications",
                "changeRecordStatus": "Modifier le statut de la fiche",
                "statusModificationWarning": "Confirmer la modification ?",
                "offlineWarning": "Les modifications sont sauvegardées sur l'appareil, vous devrez les synchroniser avec la base de données lorsque le réseau sera de nouveau disponible.",
                "offlineShortWarning": "Modifié sur cet appareil"
            },
            "notifications": {
                "saveError": "Une erreur est survenue lors de la sauvegarde",
                "saveSuccess": "Fiche de récolement sauvegardée",
                "stateTransitionError": "Une erreur est survenue pendant la modification du statu de la fiche",
                "stateTransitionSuccess": "Statut de la fiche modifié avec succès",
                "addToCampaign": "Récoler cet objet"
            }
        },
        "defectTree": {
            "annotation": {
                "deleteConfirmationMessage": "Confirmer la suppression ?",
                "defaultImageConfirmationMessage": "Définir comme image par défaut ?"
            }
        },
        "itemSearchScreen": {
            "camera": "APPAREIL PHOTO",
            "modifyRecord": "MODIFIER LA FICHE OBJET",
            "createNewItem": "CRÉER UN NOUVEL OBJET"
        },
        "searchFeaturedCard": {
            "institutionLabel": "Institution"
        },
        "auditCampaignSearchScreen": {
            "inProgress": "En cours",
            "title": "Projets de pointage/récolement en cours",
            "noResultsPlaceholder": "Vous n'êtes habilités à travailler sur aucune campagne pour le moment"
        },
        "recordSearchScreen": {
            "auditors": "Récoleurs",
            "campaignManager": "Responsable de la campagne",
            "inventoryNumber": "N° d'inventaire",
            "projectCreationDate": "Date de création du projet",
            "projectType": "Type de projet",
            "realTimeLocation": "Localisation en temps réel",
            "recordRefNumber": "Référence fiche",
            "status": "Statut",
            "title": "Fiches de récolement",
            "unknowLocation": "Localisation Inconnue",
            "menu": {
                "addItem": "Ajouter un objet"
            }
        },
        "state": {
            "all": "Tous",
            "archived": "Archivé",
            "canceled": "Annulé",
            "finalized": "Terminé",
            "inPreparation": "En préparation",
            "inProgress": "En cours",
            "programmed": "Planifié",
            "toValidated": "À valider",
            "validated": "Validé",
            "aborted": "Interrompue",
            "success": "Terminée avec succès",
            "error": "Erreur",
            "none": "Aucune synchronisation précédente"
        },
        "time": {
            "hours": "heure(s)",
            "minutes": "minute(s)",
            "seconds": "seconde(s)"
        },
        "locationSelector": {
            "inputPlaceholder": "Entrez une localisation",
            "title": "Choisissez une localisation",
            "validate": "Valider"
        },
        "synchroModal": {
            "title": "Synchronisation",
            "lastFetch": "Dernière récupération",
            "duration": "Durée",
            "status": "Statut",
            "details": "Détails",
            "lastSynchro": "Dernière synchronisation",
            "noEntityToSync": "Aucune entité à synchroniser",
            "connectionWarningPrefix": "Vous devez être connecté à internet pour pouvoir",
            "connectWarningSend": "envoyer",
            "connectWarningRetrieve": "récupérer",
            "connectionWarningSuffix": "des données",
            "noDataToSync": "Aucune donnée à synchroniser pour le moment",
            "localIconInfoPrefix": "L'icône",
            "localIconInfoSuffix": " indique que les données correspondantes ont été modifiées localement et devront être synchronisées avec la base de données distante.",
            "retrieveAll": "Tout récupérer",
            "finishedSynchros": "synchronisations terminées",
            "syncAll": "Tout synchroniser",
            "remainsToSynchronize": "Reste à synchroniser",
            "cleanImageCache": "Supprimer les images fantômes du cache",
            "cachedImagedCleaned": "Les images fantômes ont été supprimées !",
            cleanCacheDown: "Vider le cache",
            cacheDownCleaned: "Le cache a été vidé",
            cleanCacheUp: "Supprimer toutes les modifications non synchronisées",
            cacheUpCleaned: "Toute les modifications non synchronisées ont étés supprimées",
        },
        "entityNames": {
            "items": "Items",
            "auditRecords": "Fiches de récolement",
            "audits": "Projets de récolement",
            "thesaurusTerms": "Termes de thésaurus",
            "thesaurus": "Thésaurus",
            "entityFields": "Données système",
            "collaborators": "Collaborateurs",
            "authorities": "Autorités",
            "aliases": "Alias",
            "locations": "Localisations",
            works: "Oeuvres",
            expressions: "Expressions",
            manifestations: "Manifestations",
        },
        "search": {
            "options": {
                "sortType": {
                    "auditType": "Type de projet",
                    "campaignCreationDate": "Date de création de la campagne",
                    "identificationNumber": "Numéro d'identification"
                }
            },
            "queryPlaceholder": "Mots clés ou N° de campagne",
            "totalCount": "{totalResults}  Résultat(s) : 1 -"
        },
        "itemCreationImagePopup": {
            "title": "Ajouter une image",
            "addImage": "AJOUTER UNE IMAGE",
            "ignore": "PLUS TARD, IGNORER CETTE ETAPE"
        }
    },
    "nl": {
        "auth": {
            "login": {
                "error": {
                    "credentials": "Gebruikersnaam en/of paswoord incorrect",
                    "network": "Communicatie met server mislukt"
                },
                "form": {
                    "password": {
                        "error": "Gelieve uw gebruikersnaam in te geven",
                        "label": "Paswoord"
                    },
                    "submit": "Inloggen",
                    "submitting": "Inloggen…",
                    "username": {
                        "error": "Gelieve uw paswoord in te geven",
                        "label": "Gebruikersnaam"
                    }
                }
            },
            "renew": {
                "slowNetwork": "Dit lijkt langer te duren dan normaal. Gelieve de toepassing niet te sluiten.",
                "spinner": "Opnieuw online brengen…"
            }
        },
        "actionBar": {
            "newItems": "Nieuwe items",
            "auditCampaign": "Inventariscampagnes",
            "synchro": "Synchro"
        },
        "navbar": {
            "contextMenuModal": {
                "buildDate": "Ingebruikname op",
                "checkForUpdate": {
                    "help": "Als een update beschikbaar is, zal die automatisch worden geïnstalleerd",
                    "title": "Controleer op updates"
                },
                "clearCache": {
                    "help": "Als u offline bent, heeft u niet langer toegang tot de gegevens die zijn opgeslagen op het toestel.",
                    "title": "Cachegeheugen leegmaken"
                },
                "overrideLocale": {
                    "help": "Het Engels zal worden gebruikt en de instellingen van uw toestel zullen worden genegeerd.",
                    "title": "Leg Engelse taal op"
                },
                "resetLocaleOverride": {
                    "help": "De taal hangt af van de instellingen van uw toestel",
                    "title": "Reset taal"
                },
                "title": "Skin-REPORTER"
            },
            "logout": "Bent u zeker dat u wil uitloggen?"
        },
        "offlineRibbon": {
            "offline": "U bent nu offline",
            "online": "U bent nu online"
        },
        "proxy": {
            "error": {
                "default": "Er is een fout opgetreden in de bron {uri}",
                "network": "Communicatie met server mislukt",
                "notFound": "De bron {uri} kon niet worden gevonden",
                "tokenHasExpired": "Uw sessie is vervallen"
            }
        },
        "serviceWorker": {
            "updateAvailable": "Er werd een update geïnstalleerd. Klik hier om de pagina opnieuw te laden of de toepassing te herstarten."
        },
        "itemCard": {
            "detailsNotAvailable": "Geen details beschikbaar",
            "error": "Het item kan niet worden weergegeven",
            "identifier": "N° Inv. {identifier}",
            "identifierError": "Identificatiefout",
            "location": "Locatie",
            "locationLabel": "Bestemming: <strong>{title}</strong>",
            "unknownLocation": "Onbekend",
            "title": "Titel",
            "locationSelector": {
                "title": "Selecteer locatie",
                "validate": "Valideer"
            }
        },
        "entity": {
            "addItem": {
                "error": {
                    "api": "Het object kon niet worden toegevoegd",
                    "network": "Communicatie met server mislukt"
                },
                "form": {
                    "id": {
                        "alreadyAdded": "Het object bestaat reeds in deze selectie",
                        "emptyError": "Gelieve een item te scannen of zijn inventarisnummer in te geven",
                        "label": "Inventarisnummer",
                        "notFoundError": "Onbekend item"
                    },
                    "location": {
                        "emptyError": "Selecteer locatie",
                        "label": "Aankomstlocatie",
                        "notFoundError": "Onbekende locatie"
                    },
                    "submit": "Voeg toe",
                    "submitting": "Toevoegen…"
                },
                "modal": {
                    "title": "Voeg item toe"
                }
            },
            "closeMovement": {
                "form": {
                    "location": {
                        "inputPlaceholder": "Selecteer locatie",
                        "noResult": "Geen resultaat"
                    }
                }
            }
        },
        "firewall": {
            "collabWarningMessage": "Er is geen medewerker gelinkt aan uw account, de toepassing kan minder goed werken",
            "noGroupForUserWarningMessage": "Om SKIN-reporter te kunnen gebruiken moet uw gebruikersaccount gelinkt zijn aan een gebruikersgroep"
        },
        "maskFields": {
            "boolean": {
                "no": "Nee",
                "undefined": "Ongedefinieerd",
                "yes": "Ja"
            },
            "entitySelect": {
                "modalPlaceholder": "Trefwoorden of identificatoren"
            }
        },
        "editItemScreen": {
            "author": "Auteur",
            "inventoryNumber": "Inventarisnummer",
            "confirmButton": "Bevestig",
            "editButton": "Aanpassen",
            "saveNotification": {
                "errorMessage": "MISSING TRANSLATION",
                "successMessage": "MISSING TRANSLATION"
            },
            "deleteNotification": {
                "errorMessage": "Er is een fout opgetreden bij het verwijderen van het niet-gesynchroniseerde item",
                "successMessage": "Item succesvol verwijderd"
            },
            "deleteModificationsNotification": {
                "errorMessage": "Er is een fout opgetreden bij het verwijderen van niet-gesynchroniseerde wijzigingen",
                "successMessage": "De wijzigingen werden geannuleerd"
            },
            "errorMessages": {
                "inventoryNumberNotUnique": "MISSING TRANSLATION"
            },
            "menu": {
                "saveModifications": "Save modifications",
                "deleteNotSynchronizedNewItem": "TRANSLATING IN PROGRESS",
                "deleteModificationsNotSynchronized": "TRANSLATING IN PROGRESS",
                "offlineWarning": "Modifications are saved on this device, you will have to synchronize them with the database when the network is back.",
                "offlineShortWarning": "Modified on this device",
                "addToCampaign": "MISSING TRANSLATION"
            }
        },
        "editRecordScreen": {
            "auditDate": "Inventarisatiedatum",
            "linkedObject": "Gelinkt item",
            "realTimeLocation": "Locatie in realtime",
            "itemNotice": "Ga naar item",
            "recordStatus": "Status van de fiche",
            "foldAll": "Verminder alle",
            "unfoldAll": "Zet alle",
            "medias": {
                "accordionPanelTitle": "MEDIA'S"
            },
            "menu": {
                "saveModifications": "Bewaar wijzigingen",
                "changeRecordStatus": "Wijzig status van de fiche",
                "statusModificationWarning": "Wijziging bevestigen?",
                "offlineWarning": "De wijzigingen worden op het toestel bewaard. U moet ze synchroniseren met de databank wanneer het netwerk opnieuw beschikbaar is.",
                "offlineShortWarning": "Gewijzigd op dit toestel"
            },
            "notifications": {
                "saveError": "Er is een fout opgetreden bij het bewaren",
                "saveSuccess": "Inventarisfiche bewaard",
                "stateTransitionError": "Er is een fout opgetreden bij het wijzigen van de status van de fiche",
                "stateTransitionSuccess": "Status van de fiche met succes gewijzigd"
            }
        },
        "defectTree": {
            "annotation": {
                "deleteConfirmationMessage": "Verwijdering bevestigen?",
                "defaultImageConfirmationMessage": "Instellen als defaultbeeld?"
            }
        },
        "itemSearchScreen": {
            "camera": "FOTOTOESTEL",
            "modifyRecord": " ITEMFICHE WIJZIGEN",
            "createNewItem": "MAAK NIEUW ITEM AAN"
        },
        "searchFeaturedCard": {
            "institutionLabel": "Instelling"
        },
        "auditCampaignSearchScreen": {
            "inProgress": "In uitvoering",
            "title": "Inventarisatie in uitvoering",
            "noResultsPlaceholder": "Op dit ogenblik bent u niet bevoegd om te werken aan een campagne"
        },
        "recordSearchScreen": {
            "auditors": "Medewerkers inventarisering",
            "campaignManager": "Coördinator van de campagne",
            "inventoryNumber": "Inventarisnummer",
            "projectCreationDate": "Aanmaakdatum van het project",
            "projectType": "Soort project",
            "realTimeLocation": "Locatie in realtime",
            "recordRefNumber": "Referentienummer van de fiche",
            "status": "Status",
            "title": "Inventarisfiches",
            "unknowLocation": "Onbekende locatie",
            "menu": {
                "addItem": "Voeg item toe"
            }
        },
        "state": {
            "all": "Alle",
            "archived": "Gearchiveerd",
            "canceled": "Geannuleerd",
            "finalized": "Beëindigd",
            "inPreparation": "In voorbereiding",
            "inProgress": "In uitvoering",
            "programmed": "Gepland",
            "toValidated": "Moet worden gevalideerd",
            "validated": "Gevalideerd",
            "aborted": "Afgebroken",
            "success": "Succesvol beëindigd",
            "error": "Fout",
            "none": "Geen voorgaande synchronisatie"
        },
        "time": {
            "hours": "uur/uren",
            "minutes": "minuut/minuten",
            "seconds": "seconde(n)"
        },
        "locationSelector": {
            "inputPlaceholder": "Soort locatie",
            "title": "Selecteer locatie",
            "validate": "Valideer"
        },
        "synchroModal": {
            "title": "Synchronisatie",
            "lastFetch": "Laatste recuperatie",
            "duration": "Duur",
            "status": "Status",
            "details": "Details",
            "lastSynchro": "Laaste synchronisatie",
            "noEntityToSync": "Niks om te synchroniseren",
            "connectionWarningPrefix": "U moet verbonden zijn met het internet om te",
            "connectWarningSend": "verzenden",
            "connectWarningRetrieve": "haal terug",
            "connectionWarningSuffix": "gegevens",
            "noDataToSync": "Geen gegevens om te synchroniseren op dit ogenblik",
            "localIconInfoPrefix": "Het icoon",
            "localIconInfoSuffix": "geeft aan dat de corresponderende gegevens lokaal zijn gewijzigd en moeten worden gesynchroniseerd met de databank.",
            "retrieveAll": "haal alles terug",
            "finishedSynchros": "Synchronisatie beëindigd",
            "syncAll": "Alles synchroniseren",
            "remainsToSynchronize": "Nog te synchroniseren",
            cleanImageCache: "Spookafbeeldingen uit de cache verwijderen",
            cachedImagedCleaned: "De spookbeelden zijn verwijderd!",
            cleanCacheDown: "De cache wissen",
            cacheDownCleaned: "De cache is geleegd!",
            cleanCacheUp: "Alle niet gesynchroniseerde wijzigingen verwijderen",
            cacheUpCleaned: "Alle niet gesynchroniseerde wijzigingen zijn verwijderd!",
        },
        "entityNames": {
            "items": "Items",
            "auditRecords": "Inventarisfiches",
            "audits": "Inventariscampagnes",
            "thesaurusTerms": "Thesaurusitems",
            "thesaurus": "Thesaurus",
            "entityFields": "Systeemgegevens",
            "collaborators": "Medewerkers",
            "authorities": "Autoriteiten",
            "aliases": "Aliassen",
            "locations": "Locaties",
            works: "Werken",
            expressions: "Expressies",
            manifestations: "Verschijningsvormen",
        },
        "search": {
            "options": {
                "sortType": {
                    "auditType": "Soort project",
                    "campaignCreationDate": "Aanmaakdatum van de campagne",
                    "identificationNumber": "Identificatienummer",
                    "creationDate": "Creatiedatum",
                    "identifier": "Hoofdidentificator",
                    "lastModification": "Laaste wijziging",
                    "mainTitle": "Hoofdtitel",
                    "referenceNumber": "Referentienummer"
                }
            },
            "queryPlaceholder": "Trefwoorden of campangenummer",
            "totalCount": "{totalResults}  Resultaten: 1 -",
            "noResults": "Geen resultaat",
            "title": "Museumitems"
        },
        "itemCreationImagePopup": {
            "title": "Beeld toevoegen",
            "addImage": "BEELD TOEVOEGEN",
            "ignore": "LATER, NEGEER DEZE STAP"
        }
    },
    "es": {
        "auth": {
            "login": {
                "error": {
                    "credentials": "Sus datos de acceso son incorrectos",
                    "network": "La comunicación con el servidor ha fallado"
                },
                "form": {
                    "password": {
                        "error": "Por favor, introduzca su nombre de usuario",
                        "label": "Contraseña"
                    },
                    "submit": "Entrar en el sistema",
                    "submitting": "Conectando...",
                    "username": {
                        "error": "Por favor, introduzca su contraseña",
                        "label": "Nombre de usuario"
                    }
                }
            },
            "renew": {
                "slowNetwork": "Si parece que tarda más de lo habitual, no abandones la aplicación.",
                "spinner": "Le reconectamos..."
            }
        },
        "actionBar": {
            "newItems": "TRANSLATION IN PROGRESS",
            "auditCampaign": "TRANSLATION IN PROGRESS",
            "synchro": "TRANSLATION IN PROGRESS"
        },
        "navbar": {
            "contextMenuModal": {
                "buildDate": "Desplegado en",
                "checkForUpdate": {
                    "help": "Si hay una actualización disponible, se instalará automáticamente.",
                    "title": "Comprobar las actualizaciones"
                },
                "clearCache": {
                    "help": "Si está sin conexión, esto elimina el acceso a todos los datos almacenados en el dispositivo.",
                    "title": "Vaciar la caché"
                },
                "overrideLocale": {
                    "help": "Se utilizará el idioma inglés y se ignorará la configuración de su terminal.",
                    "title": "Forzar el idioma inglés"
                },
                "resetLocaleOverride": {
                    "help": "El idioma utilizado dependerá de la configuración de su terminal",
                    "title": "Restablecer el idioma"
                },
                "title": "Skin-REPORTER"
            },
            "logout": "¿Está seguro de que quiere desconectarse?"
        },
        "offlineRibbon": {
            "offline": "Usted está fuera de línea",
            "online": "Está conectado"
        },
        "proxy": {
            "error": {
                "default": "Se ha producido un error en el recurso {uri}",
                "network": "La comunicación con el servidor ha fallado",
                "notFound": "No se ha encontrado el recurso {uri}",
                "tokenHasExpired": "Su sesión ha expirado"
            }
        },
        "serviceWorker": {
            "updateAvailable": "Se ha instalado una actualización. Pulse aquí para recargar la página o reiniciar la aplicación"
        },
        "itemCard": {
            "detailsNotAvailable": "Detalles no disponibles",
            "error": "El objeto no se puede mostrar",
            "identifier": "Nº de inventario {identifier}",
            "identifierError": "Identificación errónea",
            "location": "Ubicación",
            "locationLabel": "Destino: <strong>{title}</strong>",
            "unknownLocation": "Desconocido",
            "title": "Título",
            "locationSelector": {
                "title": "Elije una ubicación",
                "validate": "Validar"
            }
        },
        "entity": {
            "addItem": {
                "error": {
                    "api": "No se ha podido añadir el objeto",
                    "network": "La comunicación con el servidor ha fallado"
                },
                "form": {
                    "id": {
                        "alreadyAdded": "El objeto ya existe en el movimiento",
                        "emptyError": "Por favor, escanee un artículo o introduzca su número de inventario",
                        "label": "Número de inventario",
                        "notFoundError": "El objeto es desconocido"
                    },
                    "location": {
                        "emptyError": "Seleccione una ubicación",
                        "label": "Destino de la llegada",
                        "notFoundError": "La ubicación es desconocida"
                    },
                    "submit": "Añadir",
                    "submitting": "Añadiendo..."
                },
                "modal": {
                    "title": "Añadir un objeto"
                }
            },
            "closeMovement": {
                "form": {
                    "location": {
                        "inputPlaceholder": "Introduzca una ubicación...",
                        "noResult": "No hay resultados"
                    }
                }
            }
        },
        "firewall": {
            "collabWarningMessage": "Su cuenta no tiene un colaborador asociado, la aplicación puede funcionar mal",
            "noGroupForUserWarningMessage": "El uso de SKINreporter requiere que su cuenta de usuario esté vinculada a un grupo de usuarios"
        },
        "maskFields": {
            "boolean": {
                "no": "No",
                "undefined": "No definido",
                "yes": "Sí"
            },
            "entitySelect": {
                "modalPlaceholder": "Palabras clave o identificadores..."
            }
        },
        "editItemScreen": {
            "author": "Autor",
            "inventoryNumber": "Número de inventario",
            "confirmButton": "Confirmar",
            "editButton": "Modifique",
            "saveNotification": {
                "errorMessage": "Se ha producido un error al guardar el objeto",
                "successMessage": "El objeto se ha guardado con éxito"
            },
            "deleteNotification": {
                "errorMessage": "Se ha producido un error al borrar el objeto no sincronizado",
                "successMessage": "El objeto se ha borrado con éxito"
            },
            "deleteModificationsNotification": {
                "errorMessage": "Se ha producido un error al borrar los cambios no sincronizado",
                "successMessage": "Los cambios han sido cancelados"
            },
            "errorMessages": {
                "inventoryNumberNotUnique": "MISSING TRANSLATION"
            },
            "menu": {
                "saveModifications": "Guardar los cambios",
                "deleteNotSynchronizedNewItem": "Eliminar el nuevo objeto",
                "deleteModificationsNotSynchronized": "Eliminar las modificaciones no sincronizadas",
                "offlineWarning": "Los cambios se guardan en el dispositivo, tendrá que sincronizarlos con la base de datos cuando la red vuelva a estar disponible.",
                "offlineShortWarning": "Modificado en este dispositivo",
                "addToCampaign": "MISSING TRANSLATION"
            }
        },
        "editRecordScreen": {
            "auditDate": "Fecha de reacondicionamiento",
            "linkedObject": "Objeto relacionado",
            "realTimeLocation": "Localización en tiempo real",
            "itemNotice": "Maestro de objetos",
            "recordStatus": "Estado del registro maestro",
            "foldAll": "Reducir todo",
            "unfoldAll": "Desplegar todo",
            "medias": {
                "accordionPanelTitle": "MEDIA"
            },
            "menu": {
                "saveModifications": "Guardar los cambios",
                "changeRecordStatus": "Cambiar el estado del registro",
                "statusModificationWarning": "¿Confirmar el cambio?",
                "offlineWarning": "Los cambios se guardan en el dispositivo, tendrá que sincronizarlos con la base de datos cuando la red vuelva a estar disponible.",
                "offlineShortWarning": "Modificado en este dispositivo"
            },
            "notifications": {
                "saveError": "Se ha producido un error al guardar",
                "saveSuccess": "Registro guardado de la condición",
                "stateTransitionError": "Se ha producido un error al cambiar el estado del registro",
                "stateTransitionSuccess": "Estado del registro modificado con éxito"
            }
        },
        "defectTree": {
            "annotation": {
                "deleteConfirmationMessage": "¿Confirmar el borrado?",
                "defaultImageConfirmationMessage": "¿Establecer como imagen principal?"
            }
        },
        itemSearchScreen: {
            camera: 'MISSING TRANSLATION',
            modifyRecord: 'MISSING TRANSLATION',
            createNewItem: 'MISSING TRANSLATION',
        },
        searchFeaturedCard: { institutionLabel: 'Institución' },
        auditCampaignSearchScreen: {
            inProgress: 'En proceso',
            title: 'Proyectos de calificación/recuperación en proceso',
            noResultsPlaceholder: 'No puede trabajar en ninguna campaña en este momento',
        },
        recordSearchScreen: {
            auditors: 'Cosechadoras',
            campaignManager: 'Director de campaña',
            inventoryNumber: 'Número de inventario',
            projectCreationDate: 'Fecha de creación del proyecto',
            projectType: 'Tipo de proyecto',
            realTimeLocation: 'Localización en tiempo real',
            recordRefNumber: 'Referencia del archivo',
            status: 'Estado',
            title: 'Hojas de recogida',
            unknowLocation: 'Ubicación desconocida',
            menu: { addItem: 'Añadir un objeto' },
        },
        state: {
            all: 'Todos',
            archived: 'Archivado',
            canceled: 'Cancelado',
            finalized: 'Completado',
            inPreparation: 'En preparación',
            inProgress: 'En proceso',
            programmed: 'Planificado',
            toValidated: 'Por validar',
            validated: 'Validado',
            aborted: 'Interrumpido',
            success: 'Completado con éxito',
            error: 'Error',
            none: 'No hay sincronización previa',
        },
        time: { hours: 'hora(s)', minutes: 'minuto(s)', seconds: 'segundo(s)' },
        locationSelector: {
            inputPlaceholder: 'Introduzca una ubicación',
            title: 'Elija una ubicación',
            validate: 'Validar',
        },
        synchroModal: {
            title: 'Sincronización',
            lastFetch: 'Última recuperación',
            duration: 'Duración',
            status: 'Estado',
            details: 'Detalles',
            lastSynchro: 'Última sincronización',
            noEntityToSync: 'No hay entidades que sincronizar',
            connectionWarningPrefix: 'Debe estar conectado al Internet para poder',
            connectWarningSend: 'enviar',
            connectWarningRetrieve: 'recuperar',
            connectionWarningSuffix: 'datos',
            noDataToSync: 'No hay datos que sincronizar por el momento',
            localIconInfoPrefix: 'El icono',
            localIconInfoSuffix:
                ' indica que los datos correspondientes han sido modificados localmente y tendrán que ser sincronizados con la base de datos remota.',
            retrieveAll: 'Recuperar todo',
            finishedSynchros: 'sincronizaciones completadas',
            syncAll: 'Sincronizar todo',
            remainsToSynchronize: 'Restos por sincronizar',
            cleanImageCache: "Eliminar imágenes fantasma de la cache",
            cachedImagedCleaned: "Se han eliminado las imágenes fantasma",
            cleanCacheDown: "Borrar la cache",
            cacheDownCleaned: "Se ha vaciado la cache",
            cleanCacheUp: "Borrar todos los cambios no sincronizados",
            cacheUpCleaned: "Se han eliminado todos los cambios no sincronizados",
        },
        entityNames: {
            items: 'Artículos',
            auditRecords: 'Hojas de recogida',
            audits: 'Proyectos de reconstrucción',
            thesaurusTerms: 'Términos del tesauro',
            thesaurus: 'Tesauro',
            entityFields: 'Datos del sistema',
            collaborators: 'Personal',
            authorities: 'Autoridades',
            aliases: 'Alias',
            locations: 'Ubicaciones',
            works: "Obras",
            expressions: "Expresiones",
            manifestations: "Manifestaciones",
        },
        search: {
            options: {
                sortType: {
                    auditType: 'Tipo de proyecto',
                    campaignCreationDate: 'Fecha de creación de la campaña',
                    identificationNumber: 'Número de identificación',
                    creationDate: 'Fecha de creación',
                    identifier: 'Número de identificación',
                    lastModification: 'Última modificación',
                    mainTitle: 'Título principal',
                    referenceNumber: 'Número de referencia',
                },
            },
            queryPlaceholder: 'Palabras clave o número de campaña',
            totalCount: '{totalResults} Resultado(s) : 1 -',
        },
        itemCreationImagePopup: {
            title: 'MISSING TRANSLATION',
            addImage: 'MISSING TRANSLATION',
            ignore: 'MISSING TRANSLATION',
        },
    },
    "it": {
        "auth": {
            "login": {
                "error": {
                    "credentials": "Le sue credenziali non sono corrette",
                    "network": "La comunicazione con il server è fallita"
                },
                "form": {
                    "password": {
                        "error": "Inserisca il suo nome utente",
                        "label": "Password"
                    },
                    "submit": "Accesso",
                    "submitting": "Accesso...",
                    "username": {
                        "error": "Inserisca la sua password",
                        "label": "Nome dell' utente"
                    }
                }
            },
            "renew": {
                "slowNetwork": "Sembra che ci voglia più tempo del solito, non uscire dall'applicazione.",
                "spinner": "La riconnettiamo..."
            }
        },
        "actionBar": {
            "newItems": "Nuovi oggetti",
            "auditCampaign": "Le campagne di censimento",
            "synchro": "Sincronizzazione"
        },
        "navbar": {
            "contextMenuModal": {
                "buildDate": "Distribuire il",
                "checkForUpdate": {
                    "help": "Se è disponibile un aggiornamento, questo verrà installato automaticamente.",
                    "title": "Verifichi se ci sono aggiornamenti"
                },
                "clearCache": {
                    "help": "Se si è offline, si elimina l'accesso a tutti i dati memorizzati sul dispositivo.",
                    "title": "Svuotare la cache"
                },
                "overrideLocale": {
                    "help": "Verrà utilizzata la lingua inglese e le impostazioni del dispositivo verranno ignorate.",
                    "title": "Forza la lingua inglese"
                },
                "resetLocaleOverride": {
                    "help": "La lingua utilizzata dipende dalle impostazioni del dispositivo.",
                    "title": "Reimpostare la lingua"
                },
                "title": "Rivelatore di pelle"
            },
            "logout": "È sicuro di volersi scollegare?"
        },
        "offlineRibbon": {
            "offline": "È offline",
            "online": "É connesso a internet"
        },
        "proxy": {
            "error": {
                "default": "Si è verificato un errore sulla risorsa {uri}",
                "network": "La comunicazione con il server è fallita",
                "notFound": "La risorsa {uri} non è stata trovata",
                "tokenHasExpired": "La sua sessione è scaduta"
            }
        },
        "serviceWorker": {
            "updateAvailable": "È stato installato un aggiornamento. Cliccare qui per ricaricare la pagina o riavviare l'applicazione."
        },
        "itemCard": {
            "detailsNotAvailable": "Dettagli non disponibili",
            "error": "Oggetto non visualizzabile",
            "identifier": "N° Inv. {identifier}",
            "identifierError": "Errore di identificazione",
            "location": "Posizione",
            "locationLabel": "Destinazione <strong>{titolo}</strong>",
            "unknownLocation": "Sconosciuto",
            "title": "Titolo",
            "locationSelector": {
                "title": "Scegliere una posizione",
                "validate": "Validare"
            }
        },
        "entity": {
            "addItem": {
                "error": {
                    "api": "Non è stato possibile aggiungere l'oggetto",
                    "network": "Comunicazione con il server fallita"
                },
                "form": {
                    "id": {
                        "alreadyAdded": "L'oggetto esiste già nel movimento",
                        "emptyError": "Eseguire la scansione di un oggetto o inserire il numero di inventario.",
                        "label": "Numero di inventario",
                        "notFoundError": "L'oggetto è sconosciuto"
                    },
                    "location": {
                        "emptyError": "Selezionare una posizione",
                        "label": "Destinazione di arrivo",
                        "notFoundError": "La posizione è sconosciuta"
                    },
                    "submit": "Aggiungi",
                    "submitting": "Aggiungere un..."
                },
                "modal": {
                    "title": "Aggiungere un oggetto"
                }
            },
            "closeMovement": {
                "form": {
                    "location": {
                        "inputPlaceholder": "Inserire una posizione...",
                        "noResult": "Nessun risultato"
                    }
                }
            }
        },
        "firewall": {
            "collabWarningMessage": "L'account non ha un collaboratore associato, l'applicazione potrebbe non funzionare correttamente.",
            "noGroupForUserWarningMessage": "L'utilizzo di SKINreporter richiede che il proprio account utente sia collegato a un gruppo di utenti"
        },
        "maskFields": {
            "boolean": {
                "no": "No",
                "undefined": "Non definito",
                "yes": "Sì"
            },
            "entitySelect": {
                "modalPlaceholder": "Parole chiave o identificatori..."
            }
        },
        "editItemScreen": {
            "author": "Autore",
            "inventoryNumber": "Numero di inventario",
            "confirmButton": "Confermare",
            "editButton": "Modificare",
            "saveNotification": {
                "errorMessage": "Si è verificato un errore durante il salvataggio dell'oggetto",
                "successMessage": "Il backup dell'oggetto è stato eseguito con successo"
            },
            "deleteNotification": {
                "errorMessage": "Si è verificato un errore durante l'eliminazione dell'oggetto non sincronizzato",
                "successMessage": "L'oggetto è stato eliminato con successo"
            },
            "deleteModificationsNotification": {
                "errorMessage": "Si è verificato un errore durante l'eliminazione delle modifiche non sincronizzate",
                "successMessage": "Le modifiche sono state annullate"
            },
            "menu": {
                "saveModifications": "Salva le modifiche",
                "deleteNotSynchronizedNewItem": "Cancellare il nuovo oggetto",
                "deleteModificationsNotSynchronized": "Cancellare le modifiche non sincronizzate",
                "offlineWarning": "Le modifiche vengono salvate sul dispositivo",
                "offlineShortWarning": "Modificato su questo dispositivo",
                "addToCampaign": "Raccogliere questo oggetto"
            },
            "errorMessages": {
                "inventoryNumberNotUnique": "TRANSLATION IN PROGRESS"
            }
        },
        "editRecordScreen": {
            "auditDate": "Data di raccolta",
            "linkedObject": "Oggetto collegato",
            "realTimeLocation": "Posizione in tempo reale",
            "itemNotice": "Record dell'oggetto",
            "recordStatus": "Stato del record",
            "foldAll": "Ridurre tutti",
            "unfoldAll": "Aprire tutti",
            "medias": {
                "accordionPanelTitle": "MEDIA"
            },
            "menu": {
                "saveModifications": "Salva le modifiche",
                "changeRecordStatus": "Modificare lo stato del record",
                "statusModificationWarning": "Confermare il cambiamento?",
                "offlineWarning": "Le modifiche vengono salvate sul dispositivo",
                "offlineShortWarning": "Modificato su questo dispositivo"
            },
            "notifications": {
                "saveError": "Si è verificato un errore durante il salvataggio",
                "saveSuccess": "Scheda di riepilogo salvata",
                "stateTransitionError": "Si è verificato un errore durante la modifica dello stato del record",
                "stateTransitionSuccess": "Stato del record modificato con successo"
            }
        },
        "defectTree": {
            "annotation": {
                "deleteConfirmationMessage": "Confermare la cancellazione?",
                "defaultImageConfirmationMessage": "Impostare come immagine predefinita?"
            }
        },
        "itemSearchScreen": {
            "camera": "FOTOCAMERA",
            "modifyRecord": "MODIFICARE IL RECORD DELL'OGGETTO",
            "createNewItem": "CREARE UN NUOVO OGGETTO"
        },
        "searchFeaturedCard": {
            "institutionLabel": "Istituzione"
        },
        "auditCampaignSearchScreen": {
            "inProgress": "In corso",
            "title": "Progetti di registrazione/censimento in corso",
            "noResultsPlaceholder": "Non siete autorizzati a lavorare su nessuna campagna al momento"
        },
        "recordSearchScreen": {
            "auditors": "Collezionisti",
            "campaignManager": "Responsabile della campagna",
            "inventoryNumber": "Numero di inventario",
            "projectCreationDate": "Data di creazione del progetto",
            "projectType": "Tipo di progetto",
            "realTimeLocation": "Posizione in tempo reale",
            "recordRefNumber": "Riferimento al file",
            "status": "Stato",
            "title": "Fogli di stato",
            "unknowLocation": "Posizione sconosciuta",
            "menu": {
                "addItem": "Aggiungere un oggetto"
            }
        },
        "state": {
            "all": "Tutti",
            "archived": "Archiviato",
            "canceled": "Annullato",
            "finalized": "Completato",
            "inPreparation": "In preparazione",
            "inProgress": "In corso",
            "programmed": "Pianificato",
            "toValidated": "Da convalidare",
            "validated": "Convalidato",
            "aborted": "Non più in uso",
            "success": "Completato con successo",
            "error": "Errore",
            "none": "Nessuna sincronizzazione precedente"
        },
        "time": {
            "hours": "ora/e",
            "minutes": "minuti",
            "seconds": "secondo(i)"
        },
        "locationSelector": {
            "inputPlaceholder": "Inserire una posizione",
            "title": "Scegliere una posizione",
            "validate": "Convalidare"
        },
        "synchroModal": {
            "title": "Sincronizzazione",
            "lastFetch": "Ultimo recupero",
            "duration": "Durata",
            "status": "Stato",
            "details": "Dettagli",
            "lastSynchro": "Ultima sincronizzazione",
            "noEntityToSync": "Nessuna entità da sincronizzare",
            "connectionWarningPrefix": "È necessario essere collegati a internet per poter",
            "connectWarningSend": "inviare",
            "connectWarningRetrieve": "recuperare",
            "connectionWarningSuffix": "dati",
            "noDataToSync": "Al momento non ci sono dati da sincronizzare",
            "localIconInfoPrefix": "L'icona",
            "localIconInfoSuffix": " indica che i dati corrispondenti sono stati modificati localmente e dovranno essere sincronizzati con il database remoto.",
            "retrieveAll": "Recupera tutti",
            "finishedSynchros": "sincronizzazioni completate",
            "syncAll": "Sincronizzare tutti",
            "remainsToSynchronize": "Ancora da sincronizzare",
            cleanImageCache: "Rimozione delle immagini fantasma dalla cache",
            cachedImagedCleaned: "Le immagini fantasma sono state rimosse!",
            cleanCacheDown: "Pulire la cache",
            cacheDownCleaned: "La cache è stata svuotata!",
            cleanCacheUp: "Cancellare tutte le modifiche non sincronizzate",
            cacheUpCleaned: "Tutte le modifiche non sincronizzate sono state eliminate!",
        },
        "entityNames": {
            "items": "Articoli",
            "auditRecords": "Schede di raccolta",
            "audits": "Progetti di raccolta",
            "thesaurusTerms": "Termini del thesaurus",
            "thesaurus": "Tesauro",
            "entityFields": "Dati del sistema",
            "collaborators": "Collaboratori",
            "authorities": "Autorità",
            "aliases": "Alias",
            "locations": "Luoghi",
            works: "Opere",
            expressions: "Espressioni",
            manifestations: "Eventi",
        },
        "search": {
            "options": {
                "sortType": {
                    "auditType": "Tipo di progetto",
                    "campaignCreationDate": "Data di creazione della campagna",
                    "creationDate": "Data di creazione",
                    "identificationNumber": "Numero di identificazione",
                    "identifier": "Identificatore principale",
                    "lastModification": "Ultima modifica",
                    "mainTitle": "Titolo principale",
                    "referenceNumber": "Numero di riferimento"
                }
            },
            "queryPlaceholder": "Parole chiave o numero della campagna",
            "totalCount": "Risultato(i) ",
            "noResults": "Nessun risultato",
            "title": "Oggetti del museo"
        },
        "itemCreationImagePopup": {
            "title": "Aggiungere un'immagine",
            "addImage": "AGGIUNGERE UN'IMMAGINE",
            "ignore": "IN SEGUITO, SALTARE QUESTO PASSAGGIO"
        }
    },
    "no": {
        "auth": {
            "login": {
                "error": {
                    "credentials": "Brukernavn og/eller passord er feil",
                    "network": "Kommunikasjon med server mislyktes"
                },
                "form": {
                    "password": {
                        "error": "Vennligst skriv inn brukernavnet ditt",
                        "label": "Passord"
                    },
                    "submit": "Logg Inn",
                    "submitting": "Logger inn",
                    "username": {
                        "error": "Vennligst skriv inn passordet ditt",
                        "label": "Brukernavn"
                    }
                }
            },
            "renew": {
                "slowNetwork": "Dette tar mer tid enn vanlig. Vennligst ikke avslutt applikasjonen.",
                "spinner": "Får deg online igjen…"
            }
        },
        "actionBar": {
            "newItems": "Nye objekter",
            "auditCampaign": "Revisjonskampanjer",
            "synchro": "Synkron"
        },
        "navbar": {
            "contextMenuModal": {
                "buildDate": "Utplassert den",
                "checkForUpdate": {
                    "help": "Hvis en oppdatering er tilgjengelig, installeres den automatisk.",
                    "title": "Vennligst se etter oppdateringer"
                },
                "clearCache": {
                    "help": "Hvis du er frakoblet, vil dette fjerne tilgangen til alle data som er lagret på enheten din",
                    "title": "Tøm hurtigbufferminnet"
                },
                "overrideLocale": {
                    "help": "Det engelske språket vil bli brukt, og din enhets innstillinger vil bli ignorert",
                    "title": "Overstyr lokalspråket med engelsk"
                },
                "resetLocaleOverride": {
                    "help": "Språket som brukes vil avhenge av enhetens innstillinger",
                    "title": "Tilbakestill språket"
                },
                "title": "Skin-REPORTER"
            },
            "logout": "Er du sikker på at du vil logge ut?"
        },
        "offlineRibbon": {
            "offline": "Du er nå offline",
            "online": "Du er nå online"
        },
        "proxy": {
            "error": {
                "default": "Det oppsto en feil på ressursen {uri}",
                "network": "Kommunikasjon med serveren har mislyktes",
                "notFound": "Ressursen {uri} ble ikke funnet",
                "tokenHasExpired": "Økten din har utløpt"
            }
        },
        "serviceWorker": {
            "updateAvailable": "En oppdatering er installert. Du kan enten klikke her for å oppdatere siden eller start applikasjonen på nytt."
        },
        "itemCard": {
            "detailsNotAvailable": "Detaljer ikke tilgjengelige",
            "error": "Objektet kan ikke vises",
            "identifier": "Inventarnr {identifikator}",
            "identifierError": "Identifikatorfeil",
            "location": "plassering",
            "locationLabel": "Destinasjon <strong>{title}</strong>",
            "unknownLocation": "Ukjent",
            "title": "Tittel",
            "locationSelector": {
                "title": "Velg en plassering",
                "validate": "Valider"
            }
        },
        "entity": {
            "addItem": {
                "error": {
                    "api": "Objektet kunne ikke legges til",
                    "network": "Kommunikasjonen med serveren har mislyktes"
                },
                "form": {
                    "id": {
                        "alreadyAdded": "Objektet finnes allerede i denne flytting",
                        "emptyError": "Vennligst skann en strekkode for et objekt eller skriv inventarnummeret",
                        "label": "Inventarnummer",
                        "notFoundError": "Objektet er ukjent"
                    },
                    "location": {
                        "emptyError": "Velg en plassering",
                        "label": "Ankomststed",
                        "notFoundError": "Ukjent plassering"
                    },
                    "submit": "Legg til",
                    "submitting": "Legger til..."
                },
                "modal": {
                    "title": "Legg til et objekt"
                }
            },
            "closeMovement": {
                "form": {
                    "location": {
                        "inputPlaceholder": "Velg en plassering...",
                        "noResult": "Det er ikke noe resultat"
                    }
                }
            }
        },
        "firewall": {
            "collabWarningMessage": "Kontoen din har ingen tilknyttet samarbeidspartner, det kan hende at appen ikke fungerer",
            "noGroupForUserWarningMessage": "Din brukerkonto må være tilknyttet en brukergruppe for å kunne bruke SKINreporter"
        },
        "maskFields": {
            "boolean": {
                "no": "Nei",
                "undefined": "Udefinert",
                "yes": "Ja"
            },
            "entitySelect": {
                "modalPlaceholder": "Søkeord eller identifikatorer..."
            }
        },
        "editItemScreen": {
            "author": "Kunstner",
            "inventoryNumber": "Inventarnummer",
            "confirmButton": "Bekreft",
            "editButton": "Endre",
            "saveNotification": {
                "errorMessage": "Det oppsto en feil under lagring av objektet",
                "successMessage": "Objektet er lagret"
            },
            "deleteNotification": {
                "errorMessage": "Det oppstod en feil under sletting av det usynkroniserte objektet",
                "successMessage": "Objektet er slettet"
            },
            "deleteModificationsNotification": {
                "errorMessage": "Det oppstod en feil under sletting av usynkroniserte endringer",
                "successMessage": "Endringene er kansellert"
            },
            "menu": {
                "saveModifications": "Lagre endringene",
                "deleteNotSynchronizedNewItem": "Slett det nye objektet",
                "deleteModificationsNotSynchronized": "Slett usynkroniserte endringer",
                "offlineWarning": "Endringer lagres på denne enheten, du må synkronisere dem med databasen når nettverket er tilbake.",
                "offlineShortWarning": "Endret på denne enheten",
                "addToCampaign": "Revider objektet"
            },
            "errorMessages": {
                "inventoryNumberNotUnique": "TRANSLATION IN PROGRESS"
            }
        },
        "editRecordScreen": {
            "auditDate": "Revisjonsdato",
            "linkedObject": "Koblet objekt",
            "realTimeLocation": "Sanntids plassering",
            "itemNotice": "Skjema for objektet",
            "recordStatus": "Status for skjemaet",
            "foldAll": "Reduser alle",
            "unfoldAll": "Distribuere alle",
            "medias": {
                "accordionPanelTitle": "MEDIER"
            },
            "menu": {
                "saveModifications": "Lagre endringer",
                "changeRecordStatus": "Endre skjemaets status",
                "statusModificationWarning": "Bekreft endring?",
                "offlineWarning": "Endringer lagres på denne enheten, du må synkronisere dem med databasen når nettverket er tilbake.",
                "offlineShortWarning": "Endret på denne enheten"
            },
            "notifications": {
                "saveError": "Det oppsto en feil under lagring",
                "saveSuccess": "Revisjonsskjema er lagret",
                "stateTransitionError": "Det oppsto en feil under endring av skjemaet",
                "stateTransitionSuccess": "Skjemaets status ble oppdatert"
            }
        },
        "defectTree": {
            "annotation": {
                "deleteConfirmationMessage": "Bekreft sletting ?",
                "defaultImageConfirmationMessage": "Angi som standardbilde?"
            }
        },
        "itemSearchScreen": {
            "camera": "KAMERA",
            "modifyRecord": "ENDRE OBJEKTETS SKJEMA",
            "createNewItem": "OPPRETT NYTT OBJEKT"
        },
        "searchFeaturedCard": {
            "institutionLabel": "Institusjon"
        },
        "auditCampaignSearchScreen": {
            "inProgress": "Under arbeid",
            "title": "Revisjonskampanjer pågår",
            "noResultsPlaceholder": "Du er ikke autorisert til å jobbe med noen kampanje for øyeblikket"
        },
        "recordSearchScreen": {
            "auditors": "Revisorer",
            "campaignManager": "Kampanjeansvarlig",
            "inventoryNumber": "Inventarnummer",
            "projectCreationDate": "Dato for opprettelse av prosjektet",
            "projectType": "Prosjekttype",
            "realTimeLocation": "Sanntidsplassering",
            "recordRefNumber": "Skjemaets referanse",
            "status": "Status",
            "title": "Revisjonsskjemaer",
            "unknowLocation": "Ukjent plassering",
            "menu": {
                "addItem": "Legg til objekt"
            }
        },
        "state": {
            "all": "Alle",
            "archived": "Arkivert",
            "canceled": "Kansellert",
            "finalized": "Fullført",
            "inPreparation": "Under forberedelse",
            "inProgress": "pågår",
            "programmed": "Programmert",
            "toValidated": "Trenger validering",
            "validated": "Validert",
            "aborted": "Avbrutt",
            "success": "Fullført",
            "error": "Feil",
            "none": "Ingen tidligere synkronisering"
        },
        "time": {
            "hours": "time(r)",
            "minutes": "minutt(er)",
            "seconds": "sekund(er)"
        },
        "locationSelector": {
            "inputPlaceholder": "Tast inn en plassering",
            "title": "Velg en plassering",
            "validate": "Valider"
        },
        "synchroModal": {
            "title": "Synkronisering",
            "lastFetch": "Siste henting",
            "duration": "Varighet",
            "status": "Status",
            "details": "Detaljer",
            "lastSynchro": "Siste synkronisering",
            "noEntityToSync": "Ingen enhet å synkronisere",
            "connectionWarningPrefix": "Du må ha en internettforbindelse for å kunne",
            "connectWarningSend": "sende",
            "connectWarningRetrieve": "hente",
            "connectionWarningSuffix": "data",
            "noDataToSync": "Ingen data å synkronisere foreløpig",
            "localIconInfoPrefix": "Ikonet",
            "localIconInfoSuffix": " indikerer at de tilsvarende dataene har blitt endret lokalt og må synkroniseres med den eksterne databasen.",
            "retrieveAll": "Hent alle",
            "finishedSynchros": "Ferdige synkroniseringer",
            "syncAll": "Synkroniser alle",
            "remainsToSynchronize": "Gjenstår å synkronisere",
            cleanImageCache: "Fjerne spøkelsesbilder fra hurtigbufferen",
            cachedImagedCleaned: "Spøkelsesbildene er fjernet!",
            cleanCacheDown: "Tøm hurtigbufferen",
            cacheDownCleaned: "Cachen er tømt!",
            cleanCacheUp: "Slett alle usynkroniserte endringer",
            cacheUpCleaned: "Alle usynkroniserte endringer er slettet!",
        },
        "entityNames": {
            "items": "Gjenstander",
            "auditRecords": "Revisjonsskjemaer",
            "audits": "Revisjonsprosjekter",
            "thesaurusTerms": "Termer i tesaurusen",
            "thesaurus": "Tesaurus",
            "entityFields": "Systemdata",
            "collaborators": "Samarbeidspartnere",
            "authorities": "Myndigheter",
            "aliases": "Aliaser",
            "locations": "Plasseringer",
            works: "Verk",
            expressions: "Uttrykk",
            manifestations: "Arrangementer",
        },
        "search": {
            "options": {
                "sortType": {
                    "auditType": "Type prosjekt",
                    "campaignCreationDate": "Dato for opprettelse av kampanjen",
                    "creationDate": "Dato for opprettelse",
                    "identificationNumber": "Identifikasjonsnummer",
                    "identifier": "Hoved identifikator",
                    "lastModification": "Siste endring",
                    "mainTitle": "Hovedtittel",
                    "referenceNumber": "Referansenummer"
                }
            },
            "queryPlaceholder": "Nøkkelord eller kampanjenummer",
            "totalCount": "Resultat(er): 1 -",
            "noResults": "Ingen resultater",
            "title": "Museumsobjekter"
        },
        "itemCreationImagePopup": {
            "title": "Legg til et bilde",
            "addImage": "LEGG TIL ET BILDE",
            "ignore": "SENERE, HOPP OVER DETTE TRINNET "
        }
    },
    "de": {
        "auth": {
            "login": {
                "error": {
                    "credentials": "Benutzerkennung und/oder Passwort sind fehlerhaft.",
                    "network": "Die Kommunikation mit dem Server ist fehlgeschlagen."
                },
                "form": {
                    "password": {
                        "error": "Geben sie bitte ihren Benutzernamen ein.",
                        "label": "Passwort"
                    },
                    "submit": "sich einloggen",
                    "submitting": "Verbindung",
                    "username": {
                        "error": "Geben sie bitte ihr Passwort ein.",
                        "label": "Benutzername"
                    }
                }
            },
            "renew": {
                "slowNetwork": "Es dauert länger als üblich, bitte schlieẞen sie die App nicht.",
                "spinner": "Wiederaufbau der Verbindung"
            }
        },
        "actionBar": {
            "newItems": "neue Objekte",
            "auditCampaign": "Bestandsprüfungen",
            "synchro": "Synchronisation "
        },
        "navbar": {
            "contextMenuModal": {
                "buildDate": "eingesetzt am ",
                "checkForUpdate": {
                    "help": "Wenn ein Update verfügbar ist, wird es automatisch installiert.",
                    "title": "Überprüfen sie die Updates"
                },
                "clearCache": {
                    "help": "Wenn sie offline sind, wird der Zugriff auf alle auf dem Gerät gespeicherten Daten gelöscht.",
                    "title": "Den Cache leeren"
                },
                "overrideLocale": {
                    "help": "Es werden die englische Sprache verwendet und die Einstellungen ihres Terminals ignoriert.",
                    "title": "Englische Sprache erzwingen"
                },
                "resetLocaleOverride": {
                    "help": "Die verwendete Sprache hängt von den Einstellungen ihres Terminals ab.",
                    "title": "Sprache zurücksetzen"
                },
                "title": "Skin-REPORTER"
            },
            "logout": "Wollen sie sich wirklich ausloggen ?"
        },
        "offlineRibbon": {
            "offline": "Sie sind offline",
            "online": "Sie sind online"
        },
        "proxy": {
            "error": {
                "default": "Bei der Ressource {uri} ist ein Fehler aufgetreten.",
                "network": "Die Kommunikation mit dem Server ist fehlgeschlagen.",
                "notFound": "Die Ressource {uri} wurde nicht gefunden. ",
                "tokenHasExpired": "Ihre Sitzung ist abgelaufen."
            }
        },
        "serviceWorker": {
            "updateAvailable": "Es wurde ein Update installiert. Klicken sie hier, um die Seite neu zu laden oder starten sie die App neu."
        },
        "itemCard": {
            "detailsNotAvailable": "Details nicht verfügbar.",
            "error": "Das Objekt kann nicht angezeigt werden.",
            "identifier": "Nr. Inv  {identifizieren}",
            "identifierError": "Identifikationsfehler",
            "location": "Lokalisierung",
            "locationLabel": "Ziel: <strong>{Titel}</strong>",
            "unknownLocation": "Unbekannt",
            "title": "Titel",
            "locationSelector": {
                "title": "Wählen sie einen Standort aus.",
                "validate": "Bestätigen"
            }
        },
        "entity": {
            "addItem": {
                "error": {
                    "api": "Das Objekt konnte nicht hinzugefügt werden.",
                    "network": "Die Kommunikation mit dem Server ist fehlgeschlagen."
                },
                "form": {
                    "id": {
                        "alreadyAdded": "Das Objekt ist bereist in der Liste zur Verlagerung",
                        "emptyError": "Bitte scannen sie ein Objekt oder geben sie dessen Inventarnummer ein.",
                        "label": "Inventarnummer",
                        "notFoundError": "das Objekt ist unbekannt"
                    },
                    "location": {
                        "emptyError": "Wählen sie einen Standort aus",
                        "label": "Zielort",
                        "notFoundError": "Standort ist unbekannt"
                    },
                    "submit": "Hinzufügen",
                    "submitting": "Hinzufügen zu …"
                },
                "modal": {
                    "title": "Ein Objekt hinzufügen"
                }
            },
            "closeMovement": {
                "form": {
                    "location": {
                        "inputPlaceholder": "Geben sie einen Standort ein.",
                        "noResult": "Kein Ergebnis"
                    }
                }
            }
        },
        "firewall": {
            "collabWarningMessage": "Ihrem Konto ist kein Mitarbeiter zugeordnet, die App funktioniert möglicherweise nicht",
            "noGroupForUserWarningMessage": "Die Nutzung von Skin-REPORTER setzt voraus, dass ihr Benutzerkonto mit einer Benutzergruppe verknüpft ist."
        },
        "maskFields": {
            "boolean": {
                "no": "Nein",
                "undefined": "undefiniert",
                "yes": "Ja"
            },
            "entitySelect": {
                "modalPlaceholder": "Schlüsselwörter oder Identifikatoren"
            }
        },
        "editItemScreen": {
            "author": "Autor",
            "inventoryNumber": "Inventarnummer",
            "confirmButton": "Bestätigen",
            "editButton": "Bearbeiten",
            "saveNotification": {
                "errorMessage": "Beim Speichern des Objekts ist ein Fehler aufgetreten.",
                "successMessage": "Das Objekt wurde erfolgreich gespeichert."
            },
            "deleteNotification": {
                "errorMessage": "Beim Löschen des nicht synchronisierten Objekts ist ein Fehler aufgetreten.",
                "successMessage": "Das Objekt wurde erfolgreich gelöscht."
            },
            "deleteModificationsNotification": {
                "errorMessage": "Beim Löschen nicht synchronisierter Änderungen ist ein Fehler aufgetreten.",
                "successMessage": "Die Änderungen wurden rückgängig gemacht."
            },
            "menu": {
                "saveModifications": "Änderungen speichern",
                "deleteNotSynchronizedNewItem": "Das neue Objekt löschen",
                "deleteModificationsNotSynchronized": "Die nicht synchronisierten Änderungen löschen",
                "offlineWarning": "Die Änderungen sind auf dem Gerät gespeichert und müssen mit der Datenbank synchronisiert werden, sobald das Netz wieder verfügbar ist.",
                "offlineShortWarning": "Auf diesem Gerät geändert",
                "addToCampaign": "Dieses Objekt überprüfen"
            },
            "errorMessages": {
                "inventoryNumberNotUnique": "TRANSLATION IN PROGRESS"
            }
        },
        "editRecordScreen": {
            "auditDate": "Datum der Bestandsprüfung",
            "linkedObject": "verknüpftes Objekt",
            "realTimeLocation": "Standort in Echtzeit",
            "itemNotice": "Objektdatei",
            "recordStatus": "Status der Datei",
            "foldAll": "Alles verkleinern",
            "unfoldAll": "Alles einsetzen",
            "medias": {
                "accordionPanelTitle": "MEDIEN"
            },
            "menu": {
                "saveModifications": "Änderungen speichern",
                "changeRecordStatus": "Den Status der Datei ändern",
                "statusModificationWarning": "Die Änderung bestätigen ?",
                "offlineWarning": "Die Änderungen sind auf dem Gerät gespeichert und müssen mit der Datenbank synchronisiert werden, sobald das Netz wieder verfügbar ist.",
                "offlineShortWarning": "Auf diesem Gerät geändert"
            },
            "notifications": {
                "saveError": "Beim Speichern ist ein Fehler aufgetreten.",
                "saveSuccess": "Datei zur Bestandsprüfung gespeichert",
                "stateTransitionError": "Beim Ändern des Status der Datei ist ein Fehler aufgetreten.",
                "stateTransitionSuccess": "Status der Datei erfolgreich geändert"
            }
        },
        "defectTree": {
            "annotation": {
                "deleteConfirmationMessage": "Löschung bestätigen ?",
                "defaultImageConfirmationMessage": "Als Standardbild festlegen ?"
            }
        },
        "itemSearchScreen": {
            "camera": "FOTOAPPARAT",
            "modifyRecord": "OBJEKTDATEI ÄNDERN",
            "createNewItem": "EIN NEUES OBJEKT ANLEGEN"
        },
        "searchFeaturedCard": {
            "institutionLabel": "Institution"
        },
        "auditCampaignSearchScreen": {
            "inProgress": "in Arbeit",
            "title": "laufende Erhebungs- und Prüfungsmaẞnahmen",
            "noResultsPlaceholder": "Sie sind zur Zeit nicht berechtigt, an einer Bestandsprüfung teilzunehemn."
        },
        "recordSearchScreen": {
            "auditors": "Prüfeur",
            "campaignManager": "Verantwortliche der Maẞnahme",
            "inventoryNumber": "Inventarnummer",
            "projectCreationDate": "Datum der Projekterstellung`",
            "projectType": "Art des Projekts",
            "realTimeLocation": "Standort in Echtzeit",
            "recordRefNumber": "Referenz Datei",
            "status": "Status ",
            "title": "Bestandsprüfungsdateien",
            "unknowLocation": "Standort unbekannt",
            "menu": {
                "addItem": "ein Objekt hinzufügen"
            }
        },
        "state": {
            "all": "alle",
            "archived": "archiviert",
            "canceled": "storniert",
            "finalized": "beendet",
            "inPreparation": "in Vorbereitung",
            "inProgress": "in Arbeit",
            "programmed": "geplant",
            "toValidated": "zu bestätigen",
            "validated": "bestätigt",
            "aborted": "unterbrochen",
            "success": "mit Erfolg beendet",
            "error": "Fehler",
            "none": "keine vorhergehende Synchronisation"
        },
        "time": {
            "hours": "Stunde(n)",
            "minutes": "Minute(n)",
            "seconds": "Sekunde(n)"
        },
        "locationSelector": {
            "inputPlaceholder": "einen Standort eingeben",
            "title": "einen Standort auswählen",
            "validate": "bestätigen"
        },
        "synchroModal": {
            "title": "Synchronisierung",
            "lastFetch": "letzte Wiederherstellung",
            "duration": "Dauer",
            "status": "Status ",
            "details": "Details",
            "lastSynchro": "letzte Synchronisation",
            "noEntityToSync": "keine zu synchronisierende Entität",
            "connectionWarningPrefix": "Sie müssen eine Internetverbindung haben, um …",
            "connectWarningSend": "versenden",
            "connectWarningRetrieve": "wiederherstellen",
            "connectionWarningSuffix": "der Daten",
            "noDataToSync": "Derzeit keine zu synchronisierenden Daten",
            "localIconInfoPrefix": "Das Icon",
            "localIconInfoSuffix": "bedeutet, dass die entsprechenden Daten lokal geändert wurden und mit der Remote-Datenbank synchronisiert werden müssen.",
            "retrieveAll": "alles wiederherstellen",
            "finishedSynchros": "Synchronisation beendet",
            "syncAll": "alles synchronisieren",
            "remainsToSynchronize": "bleibt zu synchronisieren",
            cleanImageCache: "Geisterbilder aus dem Cache entfernen",
            cachedImagedCleaned: "Geisterbilder wurden gelöscht!",
            cleanCacheDown: "Den Cache leeren",
            cacheDownCleaned: "Der Cache wurde geleert!",
            cleanCacheUp: "Alle nicht synchronisierten Modifikationen löschen",
            cacheUpCleaned: "Alle nicht synchronisierten Modifikationen wurden gelöscht!",
        },
        "entityNames": {
            "items": "Gegenstände",
            "auditRecords": "Bestandsprüfungsdateien",
            "audits": "Prüfungsmaẞnahmen",
            "thesaurusTerms": "Begriffe des Thesaurus",
            "thesaurus": "Thesaurus",
            "entityFields": "Systemdaten",
            "collaborators": "Mitarbeiter",
            "authorities": "Personen/Körperschaften",
            "aliases": "Alias",
            "locations": "Standorte",
            works: "Werke",
            expressions: "Expressionen",
            manifestations: "Manifestationen",
        },
        "search": {
            "options": {
                "sortType": {
                    "auditType": "Art des Projekts",
                    "campaignCreationDate": "Datum der Maẞnahme",
                    "creationDate": "Erstellungsdatum",
                    "identificationNumber": "Identifikationsnummer",
                    "identifier": "Hauptkennzeichen",
                    "lastModification": "letzte Änderung",
                    "mainTitle": "Haupttitel",
                    "referenceNumber": "Referenznummer"
                }
            },
            "queryPlaceholder": "Schlüsselwort oder Nr. der Bestandsprüfungsmaẞnahme",
            "totalCount": "Resultat(e) : 1 -",
            "noResults": "kein Resultat",
            "title": "Museumsobjekt"
        },
        "itemCreationImagePopup": {
            "title": "ein Bild hinzufügen",
            "addImage": "BILD HINZUFÜGEN",
            "ignore": "SPÄTER DIESEN SCHRITT ÜBERSPRINGEN"
        }
    },
}

export const dateTimeFormats = {
    fr: {
        short: {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        },
        shortTime: {
            day: '2-digit',
            hour: 'numeric',
            minute: 'numeric',
            month: '2-digit',
            second: 'numeric',
            year: 'numeric',
        },
        year: {
            year: 'numeric',
        },
    },
}
